module.exports = __webpack_public_path__ + "img/driverAndPad.d19cc882.png";